import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';

import '@/bootstrap/directives';
import '@/bootstrap/plugins';
import '@/bootstrap/transitions';
import '@/bootstrap/global-components';
import '@/bootstrap/svgs';
import { initAxiosInstances } from '@/bootstrap/axios';
import '@/assets/scss/app.scss';

Vue.config.productionTip = false;

/**
 * Event Bus
 */
window.eventBus = new Vue();

require('./events');

initAxiosInstances();

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !store.getters.isAuthenticated) {
    store.dispatch('clearAuthAndUserData');
    next({ name: 'login' });
  } else if (
    to.matched.some(record => record.meta.requiresFinishedWizard)
    && !store.getters.hasFinishedWizard
  ) {
    next({ name: 'configuration.wizard.first.things.first' });
  } else if (
    to.matched.some(record => record.meta.requiresSpotifyIsAuthorized)
    && !store.getters.isSpotifyAuthorized
  ) {
    next({ name: 'spotify.authorization' });
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
